<script lang="ts" setup>
import { computed } from 'vue'
import LoyaltyUserBlock from '@components/Identification/LoyaltyUserBlock.vue'
import { useGtm } from '@composables/useGtm'
import { useLocale } from '@composables/useLocale'
import { useAppStore } from '@stores/app.store'
import { useRoute } from 'vue-router'
import { TRANSLATIONS_MAPPER } from '@lib/models/internal/translations'

const { t } = useLocale()
const route = useRoute()
const store = useAppStore()
const { trackMenuButton } = useGtm()

const routes = computed(() => {
  const routes = [
    {
      name: 'home',
      icon: 'home'
    }
  ]
  if (store.loyaltyTiers?.length) {
    routes.push({
      name: 'loyalty',
      icon: 'loyalty'
    })
  }
  routes.push({
    name: 'aop-coupon',
    icon: 'coupon'
  })

  return routes
})

const isRouteNameActive = (routeName: string) => routeName === route.name

const getRouteImgSrc = (route: { name: string; icon: string }) => {
  const isActive = isRouteNameActive(route.name)
  const iconName = isActive ? `${route.icon}-active` : route.icon
  return `images/navigation/${iconName}.svg`
}
</script>

<template>
  <section
    data-test="aside-menu"
    class="mb-vh-48 py-vh-16 gap-vh-16 shadow-elevation-down flex flex-col rounded bg-white"
  >
    <LoyaltyUserBlock
      v-if="store.user"
      :user="store.user"
      :locale="store.formatLocale"
      :decimals="store.config?.decimalsQty ?? 0"
    />
    <RouterLink
      v-for="menuRoute in routes"
      :key="menuRoute.name"
      v-ripple
      :data-test="`link-aside-${menuRoute.name}`"
      class="py-vh-4 px-vw-16 gap-vw-24 flex w-full cursor-pointer flex-row items-center"
      :to="{ name: menuRoute.name }"
    >
      <div
        class="gap-vw-24 flex flex-row items-center"
        @click="trackMenuButton(menuRoute.name)"
        @keydown.enter="trackMenuButton(menuRoute.name)"
      >
        <img :src="getRouteImgSrc(menuRoute)" :alt="menuRoute.name" class="h-vh-48 w-auto" />
        <p class="text-small">{{ t(TRANSLATIONS_MAPPER.HOME_MENU[menuRoute.name]) }}</p>
      </div>
    </RouterLink>
  </section>
</template>

<style scoped>
@reference "#main.css";

.router-link-exact-active {
  @apply bg-adk-secondaryIvory relative;
}

.router-link-exact-active::before {
  @apply bg-adk-main absolute top-0 left-0 h-full w-[calc(3*var(--vw))] content-[''];
}

.router-link-exact-active p {
  @apply font-bold;
}
</style>
